<template>
  <div class="tc">
    <component
      :is="call.json ? 'button' : 'div'"
      class="tc-call"
      :class="{ 'tc-call--expandable': !!call.json }"
      :type="call.json ? 'button' : undefined"
      :aria-expanded="call.json ? String(expanded) : undefined"
      @click="call.json && (expanded = !expanded)"
    >
      <v-icon icon="mdi-wrench-outline" size="14" class="text-primary" />
      <code>{{ call.name }}</code>
      <span class="tc-args text-disabled">{{ call.args }}</span>
      <v-icon
        v-if="call.json"
        icon="mdi-chevron-down"
        size="16"
        class="tc-caret text-disabled"
        :class="{ 'tc-caret--collapsed': !expanded }"
      />
    </component>
    <pre v-if="call.json && expanded" class="tc-json">{{ call.json }}</pre>
    <div class="tc-ret text-medium-emphasis">{{ call.ret }}</div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { TraceToolCall } from './landingContent'

@Options({
  props: {
    call: { type: Object, required: true },
    initiallyExpanded: { type: Boolean, default: false }
  }
})
export default class ToolCallRow extends Vue {
  call!: TraceToolCall
  initiallyExpanded!: boolean
  expanded = false

  created() {
    this.expanded = this.initiallyExpanded
  }
}
</script>

<style scoped lang="scss">
.tc {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.tc-call {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 4px 8px;
  font-family: var(--l-mono);
  font-size: 12px;
  background: transparent;
  border: none;
  padding: 0;
  width: 100%;
  text-align: left;
}
.tc-call--expandable {
  cursor: pointer;
}
.tc-call .v-icon {
  flex-shrink: 0;
  margin-top: 2px;
}
.tc-call code {
  font-family: var(--l-mono);
  background: transparent;
  font-weight: 500;
  flex-shrink: 0;
}
.tc-args {
  font-family: var(--l-mono);
  flex: 1 1 auto;
  /* keep a readable inline width; below it, the args wrap to their own line */
  min-width: min(24ch, 100%);
  word-break: break-all;
}
.tc-caret {
  margin-left: auto;
  transition: transform 0.2s;
}
.tc-caret--collapsed {
  transform: rotate(-90deg);
}
.tc-json {
  font-family: var(--l-mono);
  font-size: 11px;
  line-height: 1.6;
  color: rgb(var(--v-theme-theme-on-code));
  background: rgb(var(--v-theme-background));
  border: 1px solid var(--l-border);
  border-radius: 6px;
  padding: 12px 14px;
  margin: 2px 0 2px 22px;
  overflow-x: auto;
  white-space: pre;
}
.tc-ret {
  font-family: var(--l-mono);
  font-size: 11px;
  line-height: 1.5;
  padding-left: 22px;
  word-break: break-all;
}
</style>
